export default __webpack_public_path__ + "static/media/Sri-Krishna-Weld.b90f6f91.webp";